import { Breadcrumbs } from "@/components/ui/breadcrumbs";
import { H2 } from "@/components/ui/typography";
import { CityCreateForm } from "@/features/city/CityCreateForm";

export function CityCreate() {
  return (
    <>
      <Breadcrumbs
        list={[
          {
            label: "Master Data",
          },
          {
            href: "/master-data/city",
            label: "City (Kota/Kab)",
          },
          {
            label: "Add",
          },
        ]}
      />
      <H2>Add City (Kota/Kab)</H2>
      <CityCreateForm />
    </>
  );
}
